const HelperFileCache = {
	
	drop: async () => {
	},
	deleteFile: async ( uri ) => {
	},
	findFiles: async ( filename ) => {
		return [];
	},
	prepareFilename: ( filename ) => {
		return filename;
	},
	exists: async( filename ) => {
		return false;
	},
	
	create: async ( uri, filename, onDownload = null ) => {
		return uri;
	},
	
	ensureDirExists: async ( directory ) => {
		return false;
	},
	
	getFilename: ( uri ) => {
		return uri.substr(uri.lastIndexOf('/') + 1);
	},
	
	getExtension: ( uri ) => {
		return uri.substr(uri.lastIndexOf('.') + 1).toLowerCase();
	}
}

export default HelperFileCache
